import { ECurrency } from '../enums/currency.enum';

export const CURRENCIES = [
    {
        label: ECurrency.USD,
        value: ECurrency.USD,
    },
    {
        label: ECurrency.MXN,
        value: ECurrency.MXN,
    },
    {
        label: ECurrency.COP,
        value: ECurrency.COP,
    },
    {
        label: ECurrency.PEN,
        value: ECurrency.PEN,
    },
    {
        label: ECurrency.ARS,
        value: ECurrency.ARS,
    },
    {
        label: ECurrency.UYU,
        value: ECurrency.UYU,
    },
];
